import {
  ShoppingCart,
  PlaneTakeoff,
  DollarSign,
  Bell,
  Users,
  AlertCircle,
  Settings,
  Flame,
  Globe,
} from "lucide-react";
import type { NavigationItem } from "../types/navigation.types";

export const navigationItems: NavigationItem[] = [
  { id: "orders", label: "Заказы", path: "/", icon: ShoppingCart },
  {
    id: "manual-flights",
    label: "Ручные рейсы",
    path: "/manual-flights",
    icon: PlaneTakeoff,
  },
  { id: "markups", label: "Наценки", path: "/markups", icon: DollarSign },
  {
    id: "notifications",
    label: "Пуш-уведомления",
    path: "/notifications",
    icon: Bell,
  },
  { id: "tours", label: "Горящие предложения", path: "/tours", icon: Flame },
  { id: "entry-rules", label: "Правила въезда", path: "/entry-rules", icon: Globe },
  { id: "corporate-section", label: "Корпоративное", isSection: true },
  { id: "users", label: "Пользователи", path: "/users", icon: Users },
  { id: "logs", label: "Логи и ошибки", path: "/logs", icon: AlertCircle },
  { id: "settings", label: "Настройки", path: "/settings", icon: Settings },
];
